<template>
  <div>
    <b-table
      responsive
      v-if="tableData"
      head-variant="light"
      :fields="tableData.fields"
      :items="tableData.items"
    ></b-table>

    <b-table-simple v-else-if="$slots.tableContent" responsive>
      <slot name="tableContent"></slot>
    </b-table-simple>
  </div>
</template>

<script lang="js">
  export default  {
    name: 'lms-table',
    components: {

    },
    props: {
		tableData: {
		  type: Object
		}
    },
    data() {
      return {

      }
    },
    mounted () {

    },
    methods: {

    },
}
</script>
